// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const GifIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'gif'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91667 1.25C1.99619 1.25 1.25 1.99619 1.25 2.91667V17.0833C1.25 18.0038 1.99619 18.75 2.91667 18.75H17.0833C18.0038 18.75 18.75 18.0038 18.75 17.0833V2.91667C18.75 1.99619 18.0038 1.25 17.0833 1.25H2.91667ZM12.7272 6.59848V13.8071H14.2513V10.8293H17.1833V9.57275H14.2513V7.85507H17.5001V6.59848H12.7272ZM11.582 6.59848V13.8071H10.0579V6.59848H11.582ZM7.19899 8.47457C7.28816 8.60598 7.35738 8.75733 7.40666 8.92863H8.95539C8.90611 8.57195 8.79465 8.24578 8.62101 7.95011C8.44736 7.6521 8.22326 7.39515 7.94872 7.17927C7.67651 6.96339 7.36442 6.79678 7.01244 6.67945C6.66045 6.55978 6.28031 6.49994 5.87201 6.49994C5.39566 6.49994 4.95333 6.58324 4.54503 6.74985C4.13673 6.91645 3.77888 7.15932 3.47148 7.47846C3.16408 7.79759 2.92473 8.18712 2.75343 8.64704C2.58448 9.10462 2.5 9.62556 2.5 10.2099C2.5 10.9701 2.64197 11.6272 2.9259 12.181C3.21218 12.7324 3.6111 13.1583 4.12265 13.4587C4.6342 13.7567 5.22788 13.9057 5.90369 13.9057C6.5091 13.9057 7.04646 13.7837 7.51577 13.5396C7.98509 13.2932 8.3535 12.9436 8.62101 12.4907C8.88851 12.0355 9.02227 11.4911 9.02227 10.8575V9.94938H6.00576V11.0969H7.554C7.54777 11.385 7.48223 11.6361 7.35738 11.8501C7.22832 12.0754 7.0406 12.2502 6.79421 12.3746C6.55016 12.4966 6.25567 12.5576 5.91073 12.5576C5.53058 12.5576 5.20089 12.4661 4.92165 12.283C4.64241 12.0977 4.42653 11.829 4.274 11.477C4.12147 11.125 4.04521 10.6979 4.04521 10.1958C4.04521 9.69361 4.12265 9.26888 4.27752 8.92159C4.43239 8.57195 4.64828 8.30562 4.92517 8.12259C5.20441 7.93955 5.52824 7.84804 5.89665 7.84804C6.09376 7.84804 6.27327 7.87268 6.43518 7.92195C6.59944 7.97123 6.74493 8.0428 6.87164 8.13667C7.0007 8.22818 7.10982 8.34082 7.19899 8.47457Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
GifIcon.displayName = 'GifIcon'
export { GifIcon }
